import React from 'react';
import MaterialCardContent from '@mui/material/CardContent';
import {Divider} from '../Divider/Divider';
import {styled} from '@mui/material/styles';
import type {CardContentProps as MaterialCardContentProps} from '@mui/material/CardContent';

type FuelDivider = 'none' | 'top' | 'bottom' | string[];

export interface CardContentProps extends MaterialCardContentProps {
    /**
     * Includes divider
     * @default 'none'
     */
    divider?: FuelDivider;
}

const StyledCardContent = styled(MaterialCardContent)(({theme}) => ({
    '&:last-child': {
        paddingBottom: theme.spacing(4)
    }
}));

export const CardContent = React.forwardRef<any, CardContentProps>(
    (
        {
            divider = 'none',
            children,
            ...props
        },
        ref
    ) => {
        return (
            <>
                { (divider === 'top' || divider.includes('top')) && <Divider/> }
                <StyledCardContent
                    ref={ref}
                    {...props}
                >
                    {children}
                </StyledCardContent>
                { (divider === 'bottom' || divider.includes('bottom')) && <Divider/> }
            </>
        );
    });

CardContent.displayName = 'CardContent';
